import React from 'react'
import { ResponsivePie } from '@nivo/pie'

import { useColorMode } from "@chakra-ui/react";
import { themeDark, border, chartColors, tooltip } from 'variables/nivo/default'
import { arc, arcLinkLabelsColor, arcLabelsTextColor, margin, legendsDark, legendsLight, pieProps } from 'variables/nivo/pie'

const data = [
	{
		id: "nenhuma",
    label: "Nenhuma vez por semana",
    value: Math.floor(Math.random() * (100 - 0) + 0),
	},
	{
		id: "menos_tres",
    label: "Menos de três vezes por semana",
    value: Math.floor(Math.random() * (100 - 0) + 0),
	},
	{
		id: "tres",
    label: "Três vezes por semana",
    value: Math.floor(Math.random() * (100 - 0) + 0),
	},
	{
		id: "quatro",
    label: "Quatro vezes por semana",
    value: Math.floor(Math.random() * (100 - 0) + 0),
	},
	{
		id: "quase_sempre",
    label: "Quase Sempre",
    value: Math.floor(Math.random() * (100 - 0) + 0),
	},
]

const total = () => {
	let total = 0;
	data.map(item => {
		total += item.value;
	})

	return total;
}

const PhysicActivityChart = () => {
 const { colorMode } = useColorMode();

  return (
    <ResponsivePie
			data={data}
			margin={margin}
			colors={chartColors}
			theme={themeDark}
			{...border}
			{...arc}
			arcLinkLabelsColor={arcLinkLabelsColor}
			arcLabelsTextColor={arcLabelsTextColor}
			legends={colorMode === 'light' ? legendsLight : legendsDark}
			tooltip={({datum}) => tooltip(datum.label, datum.value, total(), datum.color)}
			{...pieProps}
      innerRadius={0.7}
    />
  )
}

export default PhysicActivityChart